import { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { FaSpinner } from "react-icons/fa6";
import httpService from "../../services/httpService";
import ScheduleCalendar from "../clubWizard/ScheduleCalendar";
import EpisodeScheduleList from "../clubWizard/EpisodeScheduleList";

const getNextMonday = (fromDate) => {
    const date = new Date(fromDate);
    const day = date.getDay();
    const daysUntilMonday = day === 1 ? 0 : day === 0 ? 1 : 8 - day;
    date.setDate(date.getDate() + daysUntilMonday);
    return date;
};

const ClubSchedule = ({ clubGuid }) => {
    const [episodes, setEpisodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setLoading(true);
        httpService.get(`/dash/wizard/get-step/5/${clubGuid}`)
            .then((res) => {
                const eps = (res.data.club_episodes || []).map(ep => ({
                    ...ep,
                    start_date_time: ep.pivot?.start_date_time || null,
                }));
                if (eps.length > 0 && !eps[0].start_date_time) {
                    const firstMonday = getNextMonday(new Date());
                    firstMonday.setHours(8, 0, 0, 0);
                    setEpisodes(eps.map((ep, i) => {
                        const date = new Date(firstMonday);
                        date.setDate(date.getDate() + i * 7);
                        return { ...ep, start_date_time: date.toISOString().slice(0, 16) };
                    }));
                } else {
                    setEpisodes(eps);
                }
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [clubGuid]);

    const handleEpisodeUpdate = (episodeId, field, value) => {
        setEpisodes(prev => prev.map(ep => ep.id === episodeId ? { ...ep, [field]: value } : ep));
    };

    const isScheduleValid = () => {
        if (episodes.length === 0) return false;
        return episodes.every(ep => {
            if (!ep.start_date_time) return false;
            return !isNaN(new Date(ep.start_date_time).getTime());
        });
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await httpService.post("dash/wizard/podcast-club/update-all-episodes", {
                episode_pivots: episodes,
                podcast_club_guid: clubGuid,
            });
        } catch {
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="text-center py-5"><FaSpinner className="loading_spinner" /></div>;
    }

    return (
        <div>
            <Row className="mb-4">
                <Col xs={12} className="mb-4">
                    <h5 className="mb-2">Calendar Overview</h5>
                    <p className="text-muted">Drag an episode tile to a different date to reschedule it.</p>
                    <ScheduleCalendar
                        episodes={episodes}
                        onEpisodeUpdate={handleEpisodeUpdate}
                    />
                </Col>
            </Row>

            <Row className="mb-4">
                <Col xs={12}>
                    <h5 className="mb-3">Episode Schedule</h5>
                    <EpisodeScheduleList
                        episodes={episodes}
                        onEpisodeUpdate={handleEpisodeUpdate}
                    />
                </Col>
            </Row>

            <Row>
                <Col xs={12} className="d-flex justify-content-end">
                    <Button
                        variant="primary"
                        onClick={handleSave}
                        disabled={saving || !isScheduleValid()}
                    >
                        {saving ? <FaSpinner className="loading_spinner" /> : 'Save Schedule'}
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default ClubSchedule;
